import { makeStyles, Typography, Hidden, Box, Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { dateFormater } from 'utils';
import Description from './Description';
import Progress from './Progress';
import { CourseTheme } from 'assets/themes/Course';
import { useAppSelector } from 'hooks/redux';
import { enStatus } from 'interface/course';
import ContactChannels from '../ContactChannels';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  divider: {
    background: theme.variables.courseTheme.divider,
    margin: theme.spacing(4, -1000),
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
    },
    '& h2': {
      '@media(max-width: 768px)': {
        fontSize: 20,
      },
      wordBreak: 'break-word',
      color: theme.variables.courseTheme.text,
    },
    '& p': {
      '@media(max-width: 768px)': {
        fontSize: 12,
        marginTop: 0,
      },
      marginTop: theme.spacing(2),
      color: theme.variables.courseTheme.categoryText,
    },
  },
  status: {
    '@media(max-width: 768px)': {
      marginLeft: 0,
      fontSize: 12,
    },
    background: theme.palette.success.light,
    borderRadius: 2,
    marginTop: theme.spacing(2),
    padding: theme.spacing(1, 2),
    minWidth: 'fit-content',
    color: theme.palette.grey[600],
  },
  certificateButton: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    '&:hover': {
      color: theme.palette.primary.dark,
    },
    cursor: 'pointer',
  },
  gridContainer: {
    width: 'initial',
  },
}));

const Informations = () => {
  const classes = useStyles();
  const course = useAppSelector((state) => state.course);

  const { title_color } = course.customizations;

  return (
    <>
      <div className={classes.container}>
        <div className={classes.titleContainer}>
          <div>
            <Typography
              aria-label='Título do curso'
              variant='h2'
              id='informations-course-title'
              style={title_color && { color: title_color }}
            >
              {course.title}
            </Typography>
          </div>
          {course?.expire_at && (
            <Typography
              aria-label='Status da validade do curso'
              variant='body2'
              id='informations-course-expiration'
              className={classes.status}
              component='span'
            >
              {course.status == enStatus.EXPIRED ? 'Expirou em' : 'Válido até'} {dateFormater(String(course.expire_at))}
            </Typography>
          )}
          <Typography variant='body1' id='informations-course-category'>
            {course.category.name}
          </Typography>
        </div>
        <Hidden smDown>
          <Grid container spacing={8} className={classes.gridContainer}>
            <Grid item>
              <Box maxWidth={212} width='100%'>
                <Progress size='large'>
                  <Typography
                    aria-label='Botão para visualização do certificado'
                    className={classes.certificateButton}
                    variant='body2'
                    component='a'
                  >
                    Visualizar seu certificado
                  </Typography>
                </Progress>
              </Box>
            </Grid>
            <Hidden mdDown>
              <Grid item>
                <ContactChannels />
              </Grid>
            </Hidden>
          </Grid>
        </Hidden>
      </div>

      <Hidden mdUp>
        <Box maxWidth={161} marginTop={4} marginBottom={4}>
          <Progress size='large'>
            <Typography
              aria-label='Botão para visualização do certificado'
              className={classes.certificateButton}
              variant='body2'
              component='a'
            >
              Visualizar seu certificado
            </Typography>
          </Progress>
        </Box>
      </Hidden>
      <Hidden lgUp>
        <Box maxWidth={212} width='100%'>
          <ContactChannels />
        </Box>
      </Hidden>

      <Divider className={classes.divider} />

      <Description />
    </>
  );
};

export default Informations;
